"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWidget = void 0;
const Widget_1 = require("../../core/render/Widget");
class ButtonWidget extends Widget_1.Widget {
    constructor() {
        super();
        this.button = document.createElement("button");
        this.button.classList.add("btn");
        this.renderBody = this.button;
    }
    get text() {
        return this.button.textContent;
    }
    set text(value) {
        this.button.textContent = value;
    }
    addOnClickEvent(clickEvent) {
        this.button.addEventListener("click", () => clickEvent());
    }
    shouldRender() {
        return true;
    }
}
exports.ButtonWidget = ButtonWidget;
//# sourceMappingURL=ButtonWidget.js.map